import PropTypes from 'prop-types'

import { useAvatarUrl } from '../../shared/useAvatarUrls'

/**
 * Ein Profilbild oder Firmenlogo, angemeldet geholt.
 *
 * Ersetzt das frühere Bild-Element, dem die Bildadresse direkt mitgegeben wurde.
 * Der Unterschied ist nicht sichtbar, sondern liegt im Abruf: Ein Bild-Element
 * schickt keinen Anmelde-Kopfeintrag mit, deshalb holt der Baustein das Bild
 * selbst (siehe `shared/useAvatarUrls`).
 *
 * Solange das Bild lädt oder gar nicht existiert, wird `fallback` gezeigt —
 * meist die Initialen-Grafik, die vorher schon bei fehlendem Bild kam. Ohne
 * das blitzt beim Laden eine leere Fläche auf.
 */
export default function AuthAvatar({ hashName, alt = '', className, fallback = null, ...rest }) {
	const url = useAvatarUrl(hashName)

	if (!url) return fallback

	return <img src={url} alt={alt} className={className} {...rest} />
}

AuthAvatar.propTypes = {
	hashName: PropTypes.string,
	alt: PropTypes.string,
	className: PropTypes.string,
	fallback: PropTypes.node
}
